import React, { Component } from "react";
import { getSrc } from "gatsby-plugin-image";
import Link from "../../Link";

import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
class Opinions extends Component {
  render() {
    const settings = {
      dots: false,
      infinite: true,
      speed: 1000,
      slidesToShow: this.props.articles.edges.length >= 4 ? 4 : 3,
      slidesToScroll: 1,
      autoplay: true,
      responsive: [
        {
          breakpoint: 1000,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
          },
        },
      ],
    };

    return (
      <>
        {this.props.articles.edges && (
          <Slider {...settings}>
            {this.props.articles.edges.map((post) => (
              <Link to={`/learn/${post.node.slug}/`} key={post.node.slug}>
                <div className="article-card">
                  <img
                    className="card-img-top"
                    src={getSrc(
                      post.node.featuredImage.node.localFile.childImageSharp
                        .gatsbyImageData
                    )}
                    alt={post.node.title}
                    style={{
                      maxWidth: "450px",
                    }}
                  />
                  <div className="card-body">
                    <h5 dangerouslySetInnerHTML={{ __html: post.node.title }} />
                  </div>
                </div>
              </Link>
            ))}
          </Slider>
        )}
      </>
    );
  }
}

export default Opinions;
